import { toast } from 'react-toast';
import api from 'utils/api';

export const getRoles = (query = {}) => {
    const token = localStorage.getItem('token');

    return new Promise((resolve, reject) => {
        api.get('https://billpay.mtmpay.in/Admin/api/admin/roles', {
            params: query,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => resolve(response.data))
        .catch((err) => reject(err));
    });
}


export const createRole = (data) => {
    const token = localStorage.getItem('token');

    return new Promise((resolve, reject) => {
        api.post('https://billpay.mtmpay.in/Admin/api/admin/create-user', data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => resolve(response.data))
        .catch((err) => {
            if (err?.response?.data?.message) {
                toast.error(err.response.data.message);
            } else {
                toast.error("Something went wrong.");
            }
            reject(err);
        });
    });
};

export const getRole = (id) => {
    return new Promise((resolve, reject) => {
        return api.get(`https://billpay.mtmpay.in/Admin/api/admin/roles/${id}`).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        });
    })
}

export const updateRole = (id, data) => {
    return new Promise((resolve, reject) => {
        return api.put(`https://billpay.mtmpay.in/Admin/api/admin/roles/${id}`, data).then(response => {
            toast.success("Success");
            resolve(response.data);
        }).catch(err => {
            toast.error(err.response.data.message);
            reject(err);
        });
    })
}

export const deleteRole = (id) => {
    return new Promise((resolve, reject) => {
        return api.delete(`https://billpay.mtmpay.in/Admin/api/admin/roles/${id}`).then(response => {
            toast.success("Success");
            resolve(response.data);
        }).catch(err => {
            toast.error(err.response.data.message);
            reject(err);
        });
    })
}


export const assignPermissions = (id, data) => {
    return new Promise((resolve, reject) => {
        return api.put(`https://billpay.mtmpay.in/Admin/api/admin/roles/${id}/permissions`, data).then(response => {
            toast.success("Success");
            resolve(response.data);
        }).catch(err => {
            toast.error(err.response.data.message);
            reject(err);
        });
    })
}